import { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import { InterfaceContactUs } from '../../interfaces/Interfaces';
import ContactUsList from '../../api/ContactUsList.api';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../redux/store';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Spinner,
} from 'react-bootstrap';

const Requests = () => {
  const dispatch = useDispatch<AppDispatch>(); // Type your dispatch

  const [list, setList] = useState<InterfaceContactUs[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [lastPage, setLastPage] = useState<number>(1);

  const fetchContactUsList = async (page: number) => {
    setLoading(true);
    await ContactUsList(page)
      .then((response) => {
        const listInfoObject = response.data;
        setList(listInfoObject.data);
        setCurrentPage(listInfoObject.current_page);
        setLastPage(listInfoObject.last_page);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchContactUsList(currentPage);
  }, [currentPage]);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < lastPage) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  return (
    <Card>
      <CardHeader className="fs-4">
        In this page you will find all contact us form requests which are filled
        by the website guests
      </CardHeader>
      <CardBody>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Request ID</th>
              <th>Full Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Contact IP</th>
              <th>Preferred Time</th>
              <th>Subject</th>
            </tr>
          </thead>
          <tbody>
            {loading && !list && (
              <tr className="text-center">
                <td colSpan={7}>
                  <Spinner />
                </td>
              </tr>
            )}
            {!loading && list && list.length == 0 && (
              <tr className="text-center">
                <td colSpan={7}>No contact request available</td>
              </tr>
            )}
            {list &&
              list.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.contactRequestId}</td>
                    <td>
                      {item.contactFirstName} {item.contactLastName}
                    </td>
                    <td>{item.contactPhoneNumber}</td>
                    <td>{item.contactEmail}</td>
                    <td>{item.contactIp}</td>
                    <td>{item.contactDate}</td>
                    <td>{item.contactSubject ?? 'No Subject'}</td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </CardBody>
      <CardFooter className="d-flex justify-content-between">
        <div className="">
          <Button
            variant="primary"
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            className="me-2"
          >
            Previous
          </Button>
          <Button
            variant="primary"
            onClick={handleNextPage}
            disabled={currentPage === lastPage}
            className="ms-2"
          >
            Next
          </Button>
        </div>
        <div className="">
          Page {currentPage} of {lastPage}
        </div>
      </CardFooter>
    </Card>
  );
};

export default Requests;
